module.exports = __webpack_public_path__ + "static/media/on-platinum.38c166da.png";